import React from 'react';
import PropTypes from 'prop-types';
import AccountsStore from '../../../stores/AccountsStore';
import TransactionsActionCreator from '../../../actions/TransactionsActionCreator';
import moment from 'moment';
import TransactionsDetailsComponent from '../../financial-stories/AccountDetailsNew/TransactionsDetailsComponent';
import TransactionsStoreNew from '../../../stores/TransactionsStoreNew';
import AccountPoolsStore from '../../../stores/AccountPoolsStore';
import AccountPoolsActionCreator from '../../../actions/AccountPoolsActionCreator';

let cssActiveClassForSelectedTags = [];
let suggestData = '';
const defaultSortField = 'details.when';
const defaultSortOrder = 'desc';
const defaultTypeFilter = 'all';

let defaultStartDate = moment().subtract(3, 'months');
defaultStartDate = moment(defaultStartDate).startOf('day').toISOString();
let defaultEndDate = moment().startOf('day').toISOString();

let changeOfDate = false;
let fromChangeOfDate = false;

class PoolDetails extends React.Component {
  constructor(props) {
    super(props);
    this.loadNextTransactions = this.loadNextTransactions.bind(this);
    this.tabSelect = this.tabSelect.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.getSelectedTypeTransactions =
      this.getSelectedTypeTransactions.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.settingMonthName = this.settingMonthName.bind(this);
    this.settingToDate = this.settingToDate.bind(this);
    this.settingFromDate = this.settingFromDate.bind(this);
    this.onRetryClick = this.onRetryClick.bind(this);
    this.state = {
      account: AccountsStore.getAccount(),
      transactions: TransactionsStoreNew.getTransactions(),
      sidebarFlag: false,
      transactionSuggest: TransactionsStoreNew.getSuggestData(),
      isPopUpOpen: false,
      startDate: moment().subtract(3, 'months'),
      endDate: moment(),
      showSelectionTag: false,
      accountChangeFlag: false,
      mobileRowClickIndex: -1,
      accountSummaryStyle: {},
      tagsAssignedFlag: false,
      cssActiveClassForSelectedTags: [],
      transactionsReadFlag: false,
      inProgressTransaction: false,
      flagForEditTag: false,
      openMore: false,
      collapsibleButtonName: 'More',
      iconId: 'icon-down',
      monthName: '3 months',
      accountIdFromStore: '1234',
      changeOfDate: false,
      fromChangeOfDate: false,
      accountLoad: AccountsStore.getAccountsLoadedFlag(),
      transactionServiceErrorFlag:
        TransactionsStoreNew.getTransactionsServiceErrorFlag(),
      statusResponse: TransactionsStoreNew.getStatusResponse(),
      loadTransactions: TransactionsStoreNew.getLoadTransactions(),
      accountIds: null,
    };
  }

  componentWillMount() {
    if (AccountPoolsStore.isSpecificPoolDetailsLoaded()) {
      TransactionsActionCreator.getTransactions(
        AccountPoolsStore.getSelectedAccountIds(),
        defaultSortOrder,
        defaultSortField,
        defaultTypeFilter,
        defaultStartDate,
        defaultEndDate
      );
    }
    TransactionsStoreNew.addChangeListener(this.onChangeTransactionStore);
    AccountPoolsStore.addChangeListener(this.onChangeAccountPoolStore);
  }

  componentWillUnmount() {
    TransactionsStoreNew.removeChangeListener(this.onChangeTransactionStore);
    AccountPoolsStore.removeChangeListener(this.onChangeAccountPoolStore);
  }

  onChangeTransactionStore = () => {
    this.setState({
      transactionsReadFlag: true,
      accountIds: AccountPoolsStore.getSelectedAccountIds(),
      transactions: TransactionsStoreNew.getTransactions(),
      loadTransactions: TransactionsStoreNew.getLoadTransactions(),
      transactionSuggest: TransactionsStoreNew.getSuggestData(),
      isPopUpOpen: TransactionsStoreNew.getPopUpFlag(),
    });
  };

  onChangeAccountPoolStore = () => {
    if (AccountPoolsStore.isSpecificPoolDetailsLoaded()) {
      TransactionsActionCreator.getTransactions(
        AccountPoolsStore.getSelectedAccountIds(),
        defaultSortOrder,
        defaultSortField,
        defaultTypeFilter,
        defaultStartDate,
        defaultEndDate
      );
      this.setState({
        transactionsReadFlag: true,
        accountIds: AccountPoolsStore.getSelectedAccountIds(),
      });
    } else {
      this.setState({ transactionsReadFlag: false });
    }
  };

  onSortChange(sortName, sort) {
    const { accountIds, startDate, endDate, transactionsReadFlag } = this.state;
    const sortOrder = sort;
    let sortField;
    switch (sortName) {
      case 'date':
        sortField = 'details.when';
        break;
      case 'description':
        sortField = 'details.narrative.medium.raw';
        break;
      case 'type':
        sortField = 'details.type';
        break;
      case 'amount':
        sortField = 'details.amount.value';
        break;
    }
    if (sortName === 'credit' || sortName === 'debit') {
      TransactionsActionCreator.sortSMETransactions(sortName, sort);
    } else if (transactionsReadFlag && sortName !== 'account') {
      !TransactionsStoreNew.getSearchTransactionFlag()
        ? TransactionsActionCreator.getTransactions(
            accountIds,
            sortOrder,
            sortField,
            TransactionsStoreNew.getTypeFilter(),
            this.getNewDate(startDate),
            this.getNewDate(endDate)
          )
        : TransactionsActionCreator.getTransactionSearchData(
            sortOrder,
            sortField,
            TransactionsStoreNew.getTypeFilter(),
            suggestData,
            this.getNewDate(startDate),
            this.getNewDate(endDate)
          );
    }
  }

  getNewDate(date) {
    return moment(date).startOf('day').toISOString();
  }

  getSelectedTypeTransactions(data) {
    const { startDate, endDate } = this.state;
    suggestData = data;
    this.setState({ isPopUpOpen: false }, () => {
      TransactionsActionCreator.getTransactionSearchData(
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        suggestData,
        this.getNewDate(startDate),
        this.getNewDate(endDate)
      );
    });
  }

  onDateChange(startDate, endDate) {
    const { accountIds, transactionsReadFlag } = this.state;
    this.setState(
      {
        startDate: startDate,
        endDate: endDate,
        accountChangeFlag: false,
        changeOfDate: false,
        cssActiveClassForSelectedTags: cssActiveClassForSelectedTags,
      },
      () => {
        if (transactionsReadFlag) {
          fromChangeOfDate = false;
          changeOfDate = false;
          !TransactionsStoreNew.getSearchTransactionFlag()
            ? TransactionsActionCreator.getTransactionsForMultipleAccounts(
                accountIds,
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                TransactionsStoreNew.getTypeFilter(),
                this.getNewDate(startDate),
                this.getNewDate(endDate)
              )
            : TransactionsActionCreator.getTransactionSearchData(
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                TransactionsStoreNew.getTypeFilter(),
                suggestData,
                this.getNewDate(startDate),
                this.getNewDate(endDate)
              );
        }
      }
    );
  }
  loadNextTransactions(specificAccountId) {
    const { accountIds, startDate, endDate } = this.state;

    if (specificAccountId) {
      TransactionsActionCreator.getTransactionsForMultipleAccounts(
        specificAccountId,
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        this.getNewDate(startDate),
        this.getNewDate(endDate),
        true
      );
      return;
    }

    if (!TransactionsStoreNew.getSearchTransactionFlag()) {
      TransactionsActionCreator.getTransactionsForMultipleAccounts(
        accountIds,
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        this.getNewDate(startDate),
        this.getNewDate(endDate)
      );
    } else {
      TransactionsActionCreator.getTransactionSearchData(
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        suggestData,
        this.getNewDate(startDate),
        this.getNewDate(endDate)
      );
    }
  }
  tabSelect(key) {
    const { accountIds, startDate, endDate, transactionsReadFlag } = this.state;
    TransactionsActionCreator.setApplyFilterStatus(false);
    cssActiveClassForSelectedTags = [];
    this.setState(
      { cssActiveClassForSelectedTags: cssActiveClassForSelectedTags },
      () => {
        if (transactionsReadFlag) {
          !TransactionsStoreNew.getSearchTransactionFlag() &&
          transactionsReadFlag
            ? TransactionsActionCreator.getTransactionsForMultipleAccounts(
                accountIds,
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                key,
                this.getNewDate(startDate),
                this.getNewDate(endDate)
              )
            : TransactionsActionCreator.getTransactionSearchData(
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                key,
                suggestData,
                this.getNewDate(startDate),
                this.getNewDate(endDate)
              );
        }
      }
    );
  }
  settingMonthName(_monthName) {
    this.setState({ monthName: _monthName });
  }
  settingToDate(toDate) {
    const { endDate } = this.state;
    if (
      fromChangeOfDate ||
      this.getNewDate(endDate) !== this.getNewDate(toDate)
    ) {
      changeOfDate = true;
      //remove variabe
      this.setState({ endDate: toDate, changeOfDate: true });
    } else {
      changeOfDate = false;
      this.setState({ changeOfDate: false });
    }
  }
  settingFromDate(fromDate) {
    const { startDate } = this.state;
    if (startDate !== fromDate) {
      fromChangeOfDate = true;
      this.setState({ startDate: fromDate, changeOfDate: true });
    } else {
      fromChangeOfDate = false;
      this.setState({ changeOfDate: false });
    }
  }
  onRetryClick() {
    const { startDate, endDate } = this.state;
    this.setState({ transactionServiceErrorFlag: false });
    if (!TransactionsStoreNew.getSearchTransactionFlag()) {
      TransactionsActionCreator.getTransactionsForMultipleAccounts(
        '',
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        this.getNewDate(startDate),
        this.getNewDate(endDate)
      );
    } else {
      TransactionsActionCreator.getTransactionSearchData(
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        suggestData,
        this.getNewDate(startDate),
        this.getNewDate(endDate)
      );
    }
  }
  exportTransactions = () => {
    const { startDate, endDate, accountIds } = this.state;
    AccountPoolsActionCreator.exportTransactions(
      startDate,
      endDate,
      accountIds
    );
  };

  render() {
    const transactionServiceErrorMessage = '';
    const {
      transactions,
      loadTransactions,
      account,
      transactionSuggest,
      showSelectionTag,
      startDate,
      endDate,
      accountChangeFlag,
      monthName,
      transactionServiceErrorFlag,
      statusResponse,
    } = this.state;
    return (
      <div className="account-details">
        <TransactionsDetailsComponent
          {...this.props}
          account={account}
          accountType={'current'}
          transactionReadFlag={true}
          transactions={transactions}
          loadNextTransactions={this.loadNextTransactions}
          onSort={this.onSortChange}
          loadTransactionsFlag={loadTransactions}
          isLoading={TransactionsStoreNew.getLoader()}
          showMoreLoaderFlag={TransactionsStoreNew.getShowMoreLoader()}
          tabSelect={this.tabSelect}
          isMultipleSelection={false}
          suggestData={transactionSuggest}
          isPopUpOpen={this.state.isPopUpOpen}
          getSelectedTypeTransactions={this.getSelectedTypeTransactions}
          onDateChange={this.onDateChange}
          showSelectionTag={showSelectionTag}
          startDate={startDate}
          endDate={endDate}
          accountChangeFlag={accountChangeFlag}
          monthName={monthName}
          settingMonthName={this.settingMonthName}
          settingToDate={this.settingToDate}
          settingFromDate={this.settingFromDate}
          transactionServiceErrorFlag={transactionServiceErrorFlag}
          transactionServiceErrorMessage={transactionServiceErrorMessage}
          statusErrorResponse={statusResponse}
          onRetryClick={this.onRetryClick}
          changeOfDate={changeOfDate}
          fromChangeOfDate={fromChangeOfDate}
          isAccountPool
          exportTransactions={this.exportTransactions}
          onRowClick={() => {}}
        />
      </div>
    );
  }
}
PoolDetails.propTypes = {
  content: PropTypes.shape({
    content: PropTypes.string,
  }).isRequired,
};
export { PoolDetails };
